export const updateContent = (htmlString, content) => {
    htmlString = htmlString.replace(/\\"/g, '"');

    htmlString = htmlString
        .replace(
            /"highlight-top-divider" \/>/g,
            '"highlight-top-divider"></div>'
        )
        .replace(
            /"highlight-bottom-divider" \/>/g,
            '"highlight-bottom-divider"></div>'
        );

    htmlString = htmlString
        .replace(
            /"btn-download"/g,
            `"btn-download" style="background-image: url(${content.button_icon_download});"`
        )
        .replace(
            /"btn-share"/g,
            `"btn-share" style="background-image: url(${content.button_icon_share});"`
        )
        .replace(
            /"btn-scroll"/g,
            `"btn-scroll" style="background-image: url(${content.button_icon_scroll});"`
        );

    return htmlString;
};
